import React from "react";
import dayjs from "dayjs";
import "../styles/eventFormStyles.css";
import { ChantSelect, HelpTooltip } from "../../../../../../CommonComponents";
import useContentFormParams from "../hooks/useContentFormParams";

export const TicketLinkSection = ({
  ticketId,
  ticketName,
  ticketCode,
  ticketsList,
  onChange,
}) => {
  const { formMode } = useContentFormParams();

  const formatTicketLabel = (data) => {
    const base = data.name || data.code;
    if (!data.eventDate) return base;
    const date = dayjs.unix(data.eventDate);
    return date.isValid() ? `${base} (${date.format("MMM D")})` : base;
  };

  let options = ticketsList.map((data) => ({
    label: formatTicketLabel(data),
    value: data.id,
  }));

  if (ticketId && !ticketsList.find((ticket) => ticket.id === ticketId)) {
    options = [
      {
        label: ticketName || ticketCode || ticketId,
        value: ticketId,
      },
      ...options,
    ];
  }

  return (
    <div className="event-form-field-wrapper">
      <ChantSelect
        placeholder="Select Ticket"
        label="Link to group ticket?"
        helpTooltip={
          <HelpTooltip text="Select to link the Event card to the event Ticket. You must first create the ticket in 'Group Tickets' of the dashboard." />
        }
        value={ticketId}
        onChange={onChange}
        disabled={formMode === "view"}
        options={options}
      />
    </div>
  );
};
